import cities from './cities'
const initialState = () => {
    return {
        machineId: '',
        branchOffice: 1,
        communeID: 26,
        communes: [],
        cities: cities,
        coreBusinessList: [],
        companyData: null,
        htmlPrint: JSON.parse(localStorage.getItem('html-print')) || false,
        customerCreditOptions: [],
        pchPaymentConditions: [],

        //Mobile
        mobileSelectedPaymentMethod: null,
        mobileCommentary: '',
        mobileIsQuotation: false,
        mobileStorePickup: false,
        mobileExpirationDate: 1,
        mobileCustomerEmail: '',
    }
}

export default initialState
